<template>
	<SubBarGlobal :currentCrumb="currentCrumb">
		<PageButtons />
	</SubBarGlobal>
</template>
<script>
import SubBarGlobal from 'bh-mod/components/layout/SubBarGlobal'
import PageButtons from 'bh-mod/components/layout/SubBarGlobal/PageButtons'

export default {
	components: { SubBarGlobal, PageButtons },
	computed: {
		currentCrumb() {
			if (this.$route.meta.crumbName) return false
			if (this.$route.path !== '/') return 'Unknown Page'
			return this.$store.state.appData.filterPublished ? 'Published Projects' : 'All Projects'
		},
	},
}
</script>
